/**
 * Email status
 */
export enum EmailStatus {
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  SENDING = 'SENDING',
  SENT = 'SENT',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

/**
 * Email priority
 */
export enum EmailPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

/**
 * Email category
 */
export enum EmailCategory {
  TRANSACTIONAL = 'TRANSACTIONAL',
  NOTIFICATION = 'NOTIFICATION',
  MARKETING = 'MARKETING',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
}

/**
 * Email template type
 */
export enum EmailTemplateType {
  WELCOME = 'WELCOME',
  NOTIFICATION = 'NOTIFICATION',
  CAMPAIGN = 'CAMPAIGN',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  SYSTEM = 'SYSTEM',
}
